// extracted by mini-css-extract-plugin
export default {"container":"FbkxIlS8","text":"n8QsFsE5"};